var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-default"},[_c('div',{class:'circulo-usuario '+(_vm.borda?'borda':'')+' size-'+_vm.size},[_vm._v(" "+_vm._s(_vm.inicialNome)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }